module.exports = __webpack_public_path__ + "static/img/logo_kindle.a33d89b6.png";